import React, { FunctionComponent, useMemo } from 'react';
import Card from '@Components/Card/Card';
import { ModalContainer } from '@Components/Modal/subComponents/ModalContainer/ModalContiner.styled';
import { getResponsiveModalStyles } from '@Utils/layout/layoutSupport';
import useScreen from '@Utils/hooks/useScreen';

const ModalContactPage: FunctionComponent<types.cards.IContactDetailsProps['params']> = ({
	personTitleId,
	setPersonTitleId,
	orderIncludesPlan,
	onlyGiftCardOrDigitals,
	isWfbbProcess,
	isSimplifiedCheckout,
}) => {
	const { screenClass } = useScreen();
	const styles = useMemo(() => getResponsiveModalStyles(screenClass), [screenClass]);
	return (
		<ModalContainer styles={styles}>
			<Card<types.cards.IContactDetailsProps>
				card="contactDetails"
				params={{
					personTitleId,
					setPersonTitleId,
					orderIncludesPlan,
					onlyGiftCardOrDigitals,
					isHbbWfbbProcess: false,
					isWfbbProcess,
					isSimplifiedCheckout,
				}}
				withoutContainerPadding
			/>
		</ModalContainer>
	);
};

export default ModalContactPage;
